const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/sections/fields/KostentraegerField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const KostentraegerField = generateMetaKatDropDownField(
    'ef68a3b6-9b82-463c-89df-729e8c2821dd',
    'KostentraegerField'
);
